import { FullPageContainer } from "../../common/FullPageContainer/FullPageContainer";

export const ErrorPage = () => {
  return <FullPageContainer>
    <></>
  </FullPageContainer>;
}